import React from 'react';
import BiographySection from '../components/BiographySection';
import MissionStatement from '../components/MissionStatement';
import ExperienceTimeline from '../components/ExperienceTimeline';

const About = () => {
  return (
    <main className="min-h-screen pt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8">
        <h1 className="text-4xl md:text-5xl font-bold text-light">About Us</h1>
        <p className="mt-6 text-xl text-light/80 max-w-3xl">
          Eluno Consulting provides tailored strategic advisory and technology consulting services with a focus on delivering measurable business outcomes.
        </p>
      </div>
      
      {/* Mission Statement Section */}
      <MissionStatement />
      
      {/* Biography Section */}
      <BiographySection />
      
      {/* Experience Timeline Section */}
      <ExperienceTimeline />
    </main>
  );
};

export default About;
